// extracted by mini-css-extract-plugin
export default {"wrapperSearch":"SearchInputStyle_wrapperSearch__CiaHT","searchinput":"SearchInputStyle_searchinput__k7eZ3","formField":"SearchInputStyle_formField__XK6rh"};